import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { usePdfDownload } from '../../hooks/kontakte/usePdfDownload';
import DownloadButton from './DownloadButton';

interface PdfDownloadButtonProps {
    kontaktaufnahmeId: string;
    title?: string;
    size?: 'small' | 'medium' | 'large';
    color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
}

const PdfDownloadButton: React.FC<PdfDownloadButtonProps> = ({
    kontaktaufnahmeId,
    title = 'Download PDF',
    size = 'small',
    color = 'default'
}) => {
    const downloadPdf = usePdfDownload();

    // Only render if kontaktaufnahmeId exists
    if (!kontaktaufnahmeId) {
        return null;
    }

    return (
        <DownloadButton
            onClick={() => downloadPdf(kontaktaufnahmeId)}
            icon={<PictureAsPdfIcon />}
            title={title}
            size={size}
            color={color}
        />
    );
};

export default PdfDownloadButton;

